import { Form } from 'components/organisms';
import { cashFlowInitialValues } from 'components/organisms/forms/cash-flow/CashFlowForm';

import { useCustomParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useNavigate } from 'react-router-dom';

import { useGetCost } from 'services/balance';

const Cost = () => {
  const labelId = useCustomParamId('id', '/label');
  const costId = useCustomParamId('id');

  const navigate = useNavigate();

  const cost = useGetCost(costId);

  const goToListPath = `balance`;

  const onGoToEdit = () =>
    navigate(`/label/${labelId}/cost/edit/${costId}/file`);

  return (
    <Form.CashFlow
      initialValues={
        cost.data
          ? middleware.cost.queryToForm(cost.data)
          : cashFlowInitialValues
      }
      onSubmit={() => {}}
      tittle={cost.data?.costName}
      backPath={goToListPath}
      status={{
        isLoading: cost.isLoading,
        displayMode: true,
        refetch: cost.refetch,
      }}
      topbarContent={<div className='flex'></div>}
    />
  );
};

export default Cost;
